/* eslint-disable react/prop-types */
import useScreenSize from '../../../hooks/useScreenSize';
import { CloseIcon } from '../../../icons';
import { palette } from '../../../styles/_palette';
import {
  Header,
  HeaderLeftAction,
  HeaderBackButton,
  HeaderCloseButton,
  HeaderTitle,
  HeaderTitleWrapper,
  HeaderRightAction,
  HeaderBottom
} from './styled';
import { HeaderPosition, BackButtonIconEnum, PageHeaderProps } from './types';

export const PageHeader: React.FC<PageHeaderProps> = ({
  id,
  titleCypress,
  title,
  titleIcon,
  height = 60,
  icon = BackButtonIconEnum.Back,
  backButtonCypress,
  rightBlock,
  bottomBlock,
  onClick,
  showHeaderBorder = true,
  closeButtonAlign = 'left',
  headerPosition = HeaderPosition.Sticky,
  headerTag,
  styles
}) => {
  const { isSmall } = useScreenSize();

  return (
    <>
      <Header
        id={id}
        height={height}
        showHeaderBorder={showHeaderBorder}
        headerPosition={headerPosition}
        $styles={styles}
      >
        <HeaderLeftAction closeButtonAlign={closeButtonAlign}>
          {icon === BackButtonIconEnum.Back ? (
            <HeaderBackButton
              type="button"
              data-cy={backButtonCypress}
              onClick={onClick}
            />
          ) : (
            <HeaderCloseButton
              data-cy={backButtonCypress}
              type="button"
              onClick={onClick}
            >
              <CloseIcon fill={palette.heatheredGrey} width={15} height={15} />
            </HeaderCloseButton>
          )}
        </HeaderLeftAction>

        {title && (
          <HeaderTitleWrapper>
            {titleIcon}
            <HeaderTitle
              data-cy={titleCypress}
              tag={headerTag || (isSmall ? 'h3' : 'h4_new')}
            >
              {title}
            </HeaderTitle>
          </HeaderTitleWrapper>
        )}

        {rightBlock && <HeaderRightAction>{rightBlock}</HeaderRightAction>}
      </Header>
      {bottomBlock && <HeaderBottom>{bottomBlock}</HeaderBottom>}
    </>
  );
};
